import React from "react";
import { BarChart3, Eye, Target, Calculator } from "lucide-react";

const FeatureCards = () => {
  // آرایه‌ای از ویژگی‌ها برای نمایش در کارت‌ها
  const features = [
    {
      id: 1,
      icon: BarChart3,
      title: "پایش لحظه‌ای",
      delay: 100,
      description: "رصد آنلاین وضعیت محصولات و فرآیندها",
    },
    {
      id: 2,
      icon: Eye,
      title: "شفافیت مالی",
      delay: 200,
      description: "دسترسی کامل به کلیه صورت‌حساب‌ها و تراکنش‌ها",
    },
    {
      id: 3,
      icon: Target,
      title: "دقت بالا",
      delay: 300,
      description: "محاسبات دقیق و بدون خطای اطلاعات",
    },
    {
      id: 4,
      icon: Calculator,
      title: "محاسبات پیشرفته",
      delay: 400,
      description: "آنالیز داده‌ها با الگوریتم‌های پیشرفته",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-10">
      {features.map((feature) => (
        <div
          key={feature.id}
          className="feature-card p-4 flex flex-col md:flex-row md:justify-between md:items-center rounded-xl border border-green-100 bg-white/80 backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-300 hover:border-green-200"
          data-aos="fade-up"
          data-aos-delay={feature.delay}
        >
          <div className="bg-green-100 p-3 rounded-full mr-0 md:mr-3 mb-2 md:mb-0 self-end md:self-auto">
            <feature.icon size={20} className="text-green-600" />
          </div>
          <div className="text-right">
            <span className="text-sm font-medium text-gray-800 block">
              {feature.title}
            </span>
            {feature.description && (
              <span className="text-xs text-gray-500 block mt-1">
                {feature.description}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureCards;
